import { lwOn } from '../core/livewire.js';
import { initScanner } from './scanner.js';
import { SEARCH } from '../features/search.js';
import { ATTENDANCE } from '../features/attendance.js';
import { proceed } from '../features/scan.js';

let _wired = false;

export function attachUiListeners(checkinType, is_simulator) {
    const boot = async () => {
        if (_wired) return; // avoid double wiring (e.g., if called twice)
        _wired = true;

        if (!is_simulator) {
            const ttl = checkinType === 'COUNTING' ? 3000 : 10_000;
            const scanner = initScanner({ mode: 'back', ttl });
        }

        if (checkinType === 'COUNTING') {
            let lastScanTime = 0;

            lwOn('checkin.scan.success', (event) => {
                lastScanTime = Date.now();
                let classname = 'bg-danger';
                if (event.scan_status) {
                    classname = event.scan_status === 'warning' ? 'bg-success' : `bg-${event.scan_status}`;
                }
                document.body.classList.add(classname);
                proceed(event.badge_uuid);
            });

            setInterval(() => {
                if (lastScanTime && Date.now() - lastScanTime > 2000) {
                    lastScanTime = 0;
                    document.body.classList.remove('bg-success', 'bg-danger', 'bg-warning');
                }
            }, 250);
        } else {
            lwOn('checkin.badges.initial.ready', () => {
                document.body.classList.remove('fetching');
            });

            lwOn('checkin.scan.success', ({ scan_status }) => {
                console.log('Checkin scan success');
                window.openModal?.('scanBadgeModal');
                // The status is shown in the result window (no background color of the page)
                document.body.classList.remove('bg-success', 'bg-warning', 'bg-danger');
                document.body.classList.remove('fetching');
            });

            lwOn('checkin.scan.error', () => {
                window.qrScannerPause?.();
                window.openModal?.('scanBadgeModal');
                document.body.classList.remove('bg-success', 'bg-warning', 'bg-danger');
                document.body.classList.remove('fetching');
            });

            lwOn('checkin.scan.proceeded', () => {
                window.closeModal?.('scanBadgeModal');
            });

            lwOn('checkin.scan.cancel', () => {
                window.qrScannerResume?.();
                window.closeModal?.('scanBadgeModal');
                document.body.classList.remove('bg-success', 'bg-warning', 'bg-danger');
            });
        }

        // search wiring (only after DOM ready)
        try {
            await SEARCH.init();
        } catch (e) {
            console.error('SEARCH.init failed:', e);
        }

        // attendance page: the data of the device when offline
        try {
            await ATTENDANCE.init();
        } catch (e) {
            console.error('ATTENDANCE.init failed:', e);
        }
    };

    // Run now if DOM is already parsed; otherwise wait for DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
        // ensure it runs on the next microtask so the rest of the page scripts settle
        queueMicrotask(boot);
    }
}
